<template>
  <div @click="isShow =false" id="all">
    <div class="ipt">
      <div @click.stop="isShow = !isShow" class="ipt-1">
        <div>{{word}}</div>
        <div class="icon">
          <Icon v-if="isShow" size="24" type="md-arrow-dropdown" />
          <Icon v-else size="24" type="md-arrow-dropup" />
        </div>
        <div v-if="isShow">
          <div class="triangle"></div>
          <ul class="down">
            <li @click="select(item.type,item.t)" v-for="item in liList" :key="item.id">{{item.t}}</li>
          </ul>
        </div>
      </div>
      <div class="ipt-2">
        <input
          autofocus="autofocus"
          @keyup.enter="SearchIntegration"
          v-model="keyword"
          placeholder="搜索"
          class="input"
          type="text"
        />
        <van-icon @click="SearchIntegration" name="search" />
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        @click="toDetail(item.userInfo.id)"
        v-for="item in List.filter(v => v.userInfo.name)"
        :key="item.userInfo.id"
      >
        <div v-if="item.userInfo.name" class="scholar">
          <div class="left">
            <img
              v-if="item.userInfo.headPhoto"
              :src="$global.imgUrl + item.userInfo.headPhoto"
              alt=""
            />
            <Big
              v-else
              width="60"
              height="60"
              size="20"
              :big="item.userInfo.name"
            />
          </div>
          <div class="right">
            <div class="top">
              <div :class="{new: !item.userInfo.subject}" class="author">{{ item.userInfo.name }}</div>
              <div v-if="item.userInfo.subject" class="domainD">
                <div
                  v-for="(domain,index) in item.userInfo.subject.slice(0, 2).filter(v => v.levelTwoName)"
                  :key="index"
                  class="domain"
                >
                  {{ domain.levelTwoName }}
                </div>
              </div>
            </div>
            <div class="bottom">
              <span>{{ item.userInfo.unit }}</span>
            </div>
          </div>
        </div>
      </van-cell>
    </van-list>
  </div>
</template>
<script>
import { Icon, List } from "vant";
export default {
  name: "Contentslist",
  components: {
    "van-icon": Icon,
    "van-list": List,
  },
  props: {
  },
  data() {
    return {
      liList:[
        {id:1,t:'名称',type:'name'},
        {id:2,t:'任职机构',type:'currentWorkUnit'}
      ],
      word: sessionStorage.getItem('paramStr')? JSON.parse(sessionStorage.getItem('paramStr')).word : '名称',
      type: sessionStorage.getItem('paramStr')? JSON.parse(sessionStorage.getItem('paramStr')).type : 'name',
      isShow: false,
      loading: false,
      finished: false,
      keyword: sessionStorage.getItem('paramStr')? JSON.parse(sessionStorage.getItem('paramStr')).keyword : '', // 关键字
      paramsSearch: {
        type: 2,
        pageNo: 1,
        pageSize: 12,
      },
      List: [],
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
    this.SearchIntegration();
  },
  mounted() {
  },
  methods: {
    // 触底加载
    onLoad() {
      this.paramsSearch.pageNo += 1;
      this.$apis.searchServe.userList(this.paramsSearch).then((result) => {
        if (result.data.list.length < 10) {
          result.data.list.forEach((it) => {
            if (this.List.length == 0) return;
            this.List.push(it);
          });
          this.finished = true;
        } else {
          this.loading = false;
          result.data.list.forEach((it) => {
            if (this.List.length == 0) return;
            this.List.push(it);
          });
        }
      });
    },
    // 搜索列表
    async getSearchList(data) {
      this.loading = true
      const resp = await this.$apis.searchServe.userList(data);
      if (resp.resultCode == 200) {
        if(resp.data.list.length < 10) {
          this.finished = true
        }else {
          this.loading = false
        }
        this.List = []
        this.List.push(...resp.data.list);
      }
    },
    // 跳转百家
    toDetail(id) {
      window.location.href = `${this.$global.baijiaUrl}autherplain?id=${id}`;
    },
    // 学者库整体搜索条件判断(包含筛选,下拉)
    SearchIntegration () {
      this.resetParameters() // 参数重置
      this.paramStr() // 会话存储数据
      if(this.$route.query.levelOne && this.$route.query.levelTwo) { // 该参数存在说明需要进行筛选
          let paramStr = JSON.parse(sessionStorage.getItem('paramStr')) // 取出存取的搜索条件
          if(paramStr) { // 如果之前存在搜索关键字及类型，则再此基础进行二次筛选
            if(paramStr.type == 'name') { // 判断搜索类型为名称
              this.paramsSearch.name = paramStr.keyword // 名称
            }else{ // 判断搜索类型为任职机构
              this.paramsSearch.currentWorkUnit = paramStr.keyword // 任职机构
            }
            this.paramsSearch.levelOne = this.$route.query.levelOne // 一级
            this.paramsSearch.levelTwo = this.$route.query.levelTwo // 二级
            this.getSearchList(this.paramsSearch);
          }else{ // 如果不存在搜索关键字及类型，则从全部学者中进行筛选
            this.paramsSearch.levelOne = this.$route.query.levelOne // 一级
            this.paramsSearch.levelTwo = this.$route.query.levelTwo // 二级
            this.getSearchList(this.paramsSearch);
          }
      }else{ // 不需要筛选
        if(this.keyword !== '') { // 如果关键字不为空
          if(this.type == 'name') { // 判断搜索类型为名称
            this.paramsSearch.name = this.keyword // 名称
          }else{ // 判断搜索类型为任职机构
            this.paramsSearch.currentWorkUnit = this.keyword // 任职机构
          }
          this.getSearchList(this.paramsSearch);
        }else{ // 关键字为空
          sessionStorage.removeItem('paramStr')
          this.getSearchList(this.paramsSearch);
        }
      }  
    },
    // 下拉选择
    select(type,t) {
      this.word = t
      this.type = type
      if(this.keyword == '') return
      this.SearchIntegration()
      this.paramStr()

    },
    // 参数重置
    resetParameters() {
      this.List = []
      this.paramsSearch.pageNo = 1
      this.loading = false
      this.finished = false
      this.$delete(this.paramsSearch,'name')
      this.$delete(this.paramsSearch,'currentWorkUnit')
      this.$delete(this.paramsSearch,'levelOne')
      this.$delete(this.paramsSearch,'levelTwo')
      sessionStorage.removeItem('paramStr')
    },
    // 会话存储(关键字\类型)
    paramStr() {
      if(this.keyword == '') return
      let obj = {
          keyword:this.keyword,
          type:this.type,
          word:this.word
      }
      sessionStorage.setItem('paramStr',JSON.stringify(obj))
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style','background:#F7F7F7;')
  },
  beforeDestroy() {
    document.querySelector('body').setAttribute('style','background:transparent;')
  }
};
</script>

<style scoped lang="scss">
#all {
  width: 100%;
  // background: #f7f7f7;
  & .ipt {
    width: 90%;
    height: 50px;
    border-radius: 50px;
    margin: 0px auto;
    display: flex;
    justify-content: center;
    position: fixed;
    z-index: 9999;
    top: 105px;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.432);
    background-color: #fff;
    & .ipt-1 {
      width: 150px;
      height: 100%;
      border-top-left-radius: 50px;
      border-bottom-left-radius: 50px;
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-left: 20px;
      position: relative;
      & .triangle {
        width: 15px;
        height: 15px;
        background: #ffffff;
        position: absolute;
        transform: rotate(135deg);
        -ms-transform: rotate(135deg); /* IE 9 */
        -moz-transform: rotate(135deg); /* Firefox */
        -webkit-transform: rotate(135deg); /* Safari 和 Chrome */
        -o-transform: rotate(135deg); /* Opera */
        top: 60px;
        left: 42px;
        z-index: 999;
        border-bottom: 1px solid #e5e5e5;
        border-left: 1px solid #e5e5e5;
      }
      & .icon {
        display: flex;
        flex-direction: column;
      }
      & .down {
        width: 85px;
        background: rgb(255, 255, 255);
        text-align: center;
        position: absolute;
        top: 67px;
        left: 6px;
        border: 1px solid #e5e5e5;
        line-height: 35px;
        border-radius: 10px;
        z-index: 999;
        & li {
          width: 80%;
          margin: 0 auto;
          border-top: 1px solid #e5e5e5;
        }
        & :nth-child(1) {
          border: none;
        }
      }
    }
    & .ipt-2 {
      width: 100%;
      height: 100%;
      border-top-right-radius: 50px;
      border-bottom-right-radius: 50px;
      background: #fff;
      & .van-icon {
        position: relative;
        top: -23px;
        right: 22px;
        font-size: 25px;
        float: right;
      }
      & .input {
        width: 100%;
        height: 50%;
        margin-top: 13px;
        outline: none;
        padding: 0 50px 0 20px;
        border-top-right-radius: 50px;
        border-bottom-right-radius: 50px;
        border: none;
        border-left: 1px solid #bfbfbf77;
      }
    }
  }
  & .scholar {
    width: 100%;
    background: #fff;
    border-radius: 10px;
    margin: 0 auto;
    display: flex;
    padding: 0 20px 20px 20px;
    & .left {
      width: 60px;
      margin-top: 18px;
      & img {
        width: 60px;
        height: 60px;
        border-radius: 50px;
      }
    }
    & .right {
      margin-left: 18px;
      margin-top: 20px;
      & .top {
        display: flex;
        & .author {
          font-size: 14px;
          color: #000;
          font-weight: 600;
          letter-spacing: 2px;
          white-space: nowrap;
        }
        & .domainD {
          display: flex;
          padding-top: 3px;
          word-wrap: break-word;
          & .domain {
            margin-left: 5px;
            height: 18px;
            background: #ffa710;
            color: #fff;
            border-radius: 50px;
            padding: 0 5px;
            font-size: 12px;
            line-height: 18px;
            margin-bottom: 5px;
          }
        }
      }
      & .bottom {
        font-size: 12px;
        margin-top: 5px;
        color: #999;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
}
::v-deep .van-cell {
  width: 90%;
  margin: 0 auto;
  padding: 0;
  background: #f7f7f7;
  margin-bottom: 10px;
  box-shadow: 1px 1px 5px #171b683b;
}
::v-deep .van-list {
  margin-top: 130px;
  padding-top: 40px;
  height: 100%;
}
.new{
  white-space: normal !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
